var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-sm btn-yokumiru-orange",on:{"click":_vm.openModal}},[_vm._v("\n        新規"+_vm._s(_vm.$locale.consultation_host)+"予約\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }